import {
  FilterFieldNames,
  FilterOps,
  IFieldFilterClause,
  ILeafFilterClause,
  IStringArrayValuedFieldFilterClause,
  IStringValuedFieldFilterClause,
  IStringValuedFilterClause,
  IValuedFieldFilterClause,
} from '../../spacesPlatform/models/IFilterClause';

/**
 * Finds the "in" filter among the filter clauses, if it exists, and gets its values.
 * If not present, returns null.
 */
export function getInFilter(filterClauses: ILeafFilterClause[]): ReadonlyArray<string> | null {
  const idsFilter = filterClauses.find(clause => clause.operator === FilterOps.inArray) as IStringArrayValuedFieldFilterClause;
  return (idsFilter && idsFilter.values) || null;
}

export type ExplorerGraphQLFilters = {
  readonly hasActiveWarning: boolean | null;
  readonly isCertified: boolean | null;
  readonly search: string | null;
  readonly tags: string | null;
};

export function getExplorerGraphQLFilters(filters: ILeafFilterClause[]): ExplorerGraphQLFilters {
  let hasActiveWarningFilter: boolean = null;
  let isCertifiedFilter: boolean = null;
  let searchFilter: string = null;
  let tagsFilter: string = null;

  for (const filter of filters) {
    const field = (filter as IFieldFilterClause).field;
    if (field === FilterFieldNames.isCertified) {
      isCertifiedFilter = (filter as IValuedFieldFilterClause<boolean>).value;
    } else if (field === FilterFieldNames.hasActiveWarning) {
      hasActiveWarningFilter = (filter as IValuedFieldFilterClause<boolean>).value;
    } else if (field === FilterFieldNames.hasActiveDataQualityWarning) {
      hasActiveWarningFilter = (filter as IValuedFieldFilterClause<boolean>).value;
    } else if (field === FilterFieldNames.tags && filter.operator === FilterOps.has) {
      tagsFilter = (filter as IStringValuedFieldFilterClause).value;
    } else if (filter.operator === FilterOps.matches) {
      searchFilter = (filter as IStringValuedFilterClause).value;
    }
  }

  return {
    hasActiveWarning: hasActiveWarningFilter,
    isCertified: isCertifiedFilter,
    search: searchFilter,
    tags: tagsFilter,
  };
}
